
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[slug]",
      function () {
        return require("private-next-pages/galleries/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries/[slug]"])
      });
    }
  